import * as React from 'react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { NOOP } from '~/client/src/shared/utils/noop'
import { BULLET } from '~/client/src/shared/utils/usefulStrings'

interface IModalsProps {
  isDeleteOpen: boolean
  isUpdating: boolean
  selectedCount: number
  onCancel: () => void
  onConfirm: () => void
}

export default function Modals({
  isDeleteOpen,
  isUpdating,
  selectedCount,
  onCancel,
  onConfirm,
}: IModalsProps): React.ReactElement {
  const t = Localization.translator

  return (
    <ConfirmDialog
      useRedConfirmationButton
      title={t.deleteSelected}
      isOpen={isDeleteOpen}
      loading={isUpdating}
      onCancelClicked={isUpdating ? NOOP : onCancel}
      onDoneClicked={onConfirm}
      doneTitle={`${t.yes}, ${t.delete}`}
    >
      <div className="tw:whitespace-pre-line tw:pb-2.5 tw:text-body-md">
        {t.logisticsListDescriptions.areYouWantToDelete}
        <br />
        <br />
        {BULLET} {t.logisticsListDescriptions.deletionConfirmMsg(selectedCount)}
      </div>
    </ConfirmDialog>
  )
}
